define('GeoFiltering',[], function(require, factory) {
    "use strict";

    function loadPage(url, completeUrl) {
        if (completeUrl)
            window.location.href = url;
        else
            window.location.pathName = url;
    }

    function attachBind(filter, trigger, event) {
        var i;
        var mapHandler = function (e) {
            e.addEventListener(event[i], filter);
        };
        for (i = 0; i < trigger.length; i++) {
            [].slice.call(document.querySelectorAll(trigger[i])).map(mapHandler);
        }
    }

    function GeoFilter(settings) {
        var instance = this;
        
        instance.filter = function(demand) {
            var keyName = demand.currentTarget.id;
            var criteria = settings.controls[keyName];

            if (criteria === "loadPage") {
                loadPage(settings.getPage[keyName](demand.currentTarget), (settings.completeUrl));
            }
        };

        attachBind(instance.filter, settings.trigger, settings.event);
    }

    GeoFilter.prototype.defaults = {
        controls: {},
        requestUrl: "",
        getPage: [],
        trigger: [],
        event: [],
        afterFilter: null,
        completeUrl: false
    };


    return GeoFilter;
});
